










































import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  props: {
    href: {
      type: String,
      required: true,
    },
    cta: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    buttonIcon: {
      type: String,
      default: '',
    },
    layout: {
      type: String,
      default: 'column',
      validator: (value: string) => ['column', 'row'].includes(value),
    },
  },
});
